import {Injectable} from '@angular/core';
import {ConfProxy} from '../../http/services/conf.proxy';
import {HttpObservable} from '../../http/services/http.wrapper';
import * as logManager from './log.manager';

/**
	****************************************************************
	* Proxy class for getting logger configuration from server.
	*
	* Written by: Stanislav Korobov
	****************************************************************
	*/
@Injectable()
export class LogProxy {
	constructor(private confHttp:ConfProxy) {
	}

	public getDeafultLogConfig():HttpObservable<logManager.ILoggerConfig> {
		return this.confHttp.getAnon("Log", "GetLogConfiguration", null, null);
	}

	public getAuthLogConfig():HttpObservable<logManager.ILoggerConfig> {
		return this.confHttp.get("LogAuth", "GetLogConfiguration", null, null);
	}
}
